
import {
    defineComponent, PropType,
} from '@vue/composition-api';

export default defineComponent({
    name: 'hotel-offers-tab',
    props: {
        isActive: {
            type: Boolean as PropType<boolean>,
        },
    },
});
